<app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>

<div class="row">
  <div class="col-md-12 mx-auto">
    <h3>Editar bono</h3>
  </div>
  <hr />

  <div class="d-grip gap-1 d-md-flex justify-content-md-end mb-5">
    <a [routerLink]="['/bonus/list']" class="btn btn-outline-success">
      <i class="bi bi-arrow-left-circle"></i>
      Regresar a lista de bonos
    </a>
  </div>

  <div class="col-sm-12 col-md-12 col-lg-12 mx-auto">
    <ngb-alert
      #selfClosingAlert
      type="danger"
      *ngIf="generalMessage != '' && isDisplayed"
    >
      {{ generalMessage }}
    </ngb-alert>
    <ngb-alert
      #selfClosingAlert
      type="success"
      *ngIf="generalMessage != '' && isSaved"
    >
      {{ generalMessage }}
    </ngb-alert>

    <form [formGroup]="bonusForm" (ngSubmit)="updateBonus()" novalidate>
      <div class="accordion" id="cities_accordion">
        <div class="accordion-item">
          <h2 class="accordion-header" id="cities-information">
            <button
              class="accordion-button color-header-collapse"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
              disabled
            >
              <span class="color-text"> Actualizaci&oacute;n de Bonos </span>
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            aria-labelledby="headingOne"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <div class="row">
                <div class="mb-3 form-floating col-md-6">
                  <input
                    type="text"
                    name="title"
                    id="title"
                    formControlName="title"
                    class="form-control"
                    placeholder="Nombre del bono"
                    required
                    [ngClass]="{
                      'is-invalid': submitted && f.title.errors,
                      'is-valid': submitted && !f.title.errors
                    }"
                  />
                  <label for="title" class="ms-2">Nombre de bono</label>
                </div>
                <div class="mb-3 form-floating col-md-6">
                  <input
                    type="text"
                    name="amount"
                    id="amount"
                    formControlName="amount"
                    class="form-control"
                    placeholder="Cantidad minima"
                    required
                    [ngClass]="{
                      'is-invalid': submitted && f.amount.errors,
                      'is-valid': submitted && !f.amount.errors
                    }"
                  />
                  <label for="amount" class="ms-2">Cantidad minima</label>
                </div>
              </div>

              <div class="row">
                <div class="mb-3 mt-2 col-md-6">
                  <label for="percentage" class="ms-2">
                    Porcentaje del bono
                  </label>
                  <div class="input-group mb-3">
                    <input
                      type="text"
                      name="percentage"
                      id="percentage"
                      formControlName="percentage"
                      class="form-control"
                      placeholder="Porcentaje del bono"
                      required
                      [ngClass]="{
                        'is-invalid': submitted && f.percentage.errors,
                        'is-valid': submitted && !f.percentage.errors
                      }"
                    />
                    <span class="input-group-text">%</span>
                  </div>
                </div>
                <div class="form-floating mb-3 mt-3 col-md-6">
                  <select
                    name="roleId"
                    id="roleId"
                    class="form-select"
                    aria-label="floating label select"
                    formControlName="roleId"
                    [ngClass]="{
                      'is-invalid': submitted && f.roleId.errors,
                      'is-valid': submitted && !f.roleId.errors
                    }"
                  >
                    <option value="" selected>Selecciona un rol</option>
                    <option value="{{ role.id }}" *ngFor="let role of roles">
                      {{ role.role }}
                    </option>
                  </select>
                  <label for="roleId" class="ms-3"> Selecciona un rol </label>
                </div>
              </div>
              <div class="form-floating mb-3 col-md-12">
                <select
                  name="office"
                  id="office"
                  class="form-select"
                  aria-label="floating label select"
                  formControlName="office"
                  [ngClass]="{
                    'is-invalid': submitted && f.office.errors,
                    'is-valid': submitted && !f.office.errors
                  }"
                >
                  <option value="" selected>Selecciona una sucursal</option>
                  <option
                    value="{{ office.id }}"
                    *ngFor="let office of offices"
                  >
                    {{ office.name }}
                  </option>
                </select>
                <label for="office" class="ms-1">
                  Selecciona una sucursal
                </label>
              </div>
              <div class="row">
                <div class="form-check ms-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="type"
                    id="type1"
                    value="1"
                    formControlName="type"
                    [checked]="checkedRadio == 1"
                  />
                  <label class="form-check-label" for="type1">
                    Bono de lunes a domingo
                  </label>
                </div>
                <div class="form-check ms-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="type"
                    id="type2"
                    value="2"
                    formControlName="type"
                    [checked]="checkedRadio == 2"
                  />
                  <label class="form-check-label" for="type2">
                    Bono de lunes a jueves
                  </label>
                </div>
              </div>
              <div class="col-md-6 mb-3 mt-3">
                <input
                  class="form-check-input"
                  type="checkbox"
                  formControlName="active"
                  id="active"
                />
                <label class="form-check-label ms-2" for="active">
                  Esta el bono activo?
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-3 mt-2 d-grip gap-2 d-md-flex justify-content-md-end">
        <button type="submit" class="btn btn-success">
          <i class="bi bi-plus-circle"></i>
          Actualizar
        </button>
      </div>
    </form>
  </div>
</div>
